<header
  class="header"
  [class.scrolled]="isScrolled"
  [class.dark-bg]="isDarkBackground"
  [class.light-bg]="!isDarkBackground"
  [class.mobile-menu-open]="isMobileMenuOpen"
>
  <div class="header--container">
    <!-- Logo -->
    <div class="header--logo">
      <a routerLink="/" class="logo--link">
        <img
          [src]="isDarkBackground ? '/logo.svg' : '/logo-dark.svg'"
          alt="MahaAgX"
          class="logo--image"
        />
      </a>
    </div>

    <!-- Navigation Menu -->
    <nav class="header--nav">
      <ul class="nav--menu">
        <li class="nav--item">
          <a
            routerLink="/about-mahaagx"
            class="nav--link"
            [class.nav--link-active]="isAboutPageActive()"
            (click)="closeMobileMenu()"
            >About MahaAgX</a
          >
        </li>
        <li class="nav--item">
          <button
            type="button"
            class="nav--link nav-menu--trigger"
            [class.nav--link-active]="isNavMenuActiveRoute('assets')"
            [attr.aria-expanded]="activeNavMenu === 'assets'"
            (click)="toggleNavMenu($event, 'assets')"
          >
            Assets
            <svg
              class="nav-menu--chevron"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </li>
        @if (!isHeaderLinkRestricted('/sandbox')) {
          <li class="nav--item">
            <a
              routerLink="/sandbox"
              class="nav--link"
              [class.nav--link-active]="isSandboxPageActive()"
              (click)="closeMobileMenu()"
              >Sandbox</a
            >
          </li>
        }
        <li class="nav--item">
          <a
            routerLink="/canvas"
            class="nav--link"
            [class.nav--link-active]="isCanvasPageActive()"
            (click)="closeMobileMenu()"
            >Canvas</a
          >
        </li>
        <li class="nav--item">
          <a
            routerLink="/leaderboard"
            class="nav--link"
            [class.nav--link-active]="isLeadershipPageActive()"
            (click)="closeMobileMenu()"
            >Leaderboard</a
          >
        </li>
        @if (visibleCommunityMenuItems.length) {
          <li class="nav--item">
            <button
              type="button"
              class="nav--link nav-menu--trigger"
              [class.nav--link-active]="isNavMenuActiveRoute('community')"
              [attr.aria-expanded]="activeNavMenu === 'community'"
              (click)="toggleNavMenu($event, 'community')"
            >
              Community
              <svg
                class="nav-menu--chevron"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
          </li>
        }
        <li class="nav--item">
          <button
            type="button"
            class="nav--link nav-menu--trigger"
            [class.nav--link-active]="isNavMenuActiveRoute('resources')"
            [attr.aria-expanded]="activeNavMenu === 'resources'"
            (click)="toggleNavMenu($event, 'resources')"
          >
            Resources
            <svg
              class="nav-menu--chevron"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </li>
      </ul>

      @if (activeNavMenu) {
        <div
          #navMenuPanel
          class="nav-menu--panel"
          [style.top.px]="navMenuPosition.top"
          [style.left.px]="navMenuPosition.left"
        >
          <div class="nav-menu--list">
            @for (item of activeMenuItems; track item.route) {
              <a
                [routerLink]="item.route"
                class="nav-menu--item"
                [class.nav-menu--item-active]="isNavMenuItemActive(item.route)"
                (click)="closeNavMenu(); closeMobileMenu()"
              >
                <span class="nav-menu--item-icon" aria-hidden="true">
                  @if (item.icon === 'datasets') {
                    <span
                      class="nav-menu--item-icon-asset"
                      style="--nav-icon: url('/asset-dataBank.svg')"
                    ></span>
                  }
                  @if (item.icon === 'models') {
                    <span
                      class="nav-menu--item-icon-asset"
                      style="--nav-icon: url('/asset-ai-model.svg')"
                    ></span>
                  }
                  @if (item.icon === 'usecases') {
                    <span
                      class="nav-menu--item-icon-asset"
                      style="--nav-icon: url('/asset-use-case.svg')"
                    ></span>
                  }
                  @if (item.icon === 'challenges') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="8" r="6" />
                      <path d="M8.5 13.5 7 22l5-3 5 3-1.5-8.5" />
                    </svg>
                  }
                  @if (item.icon === 'discussions') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M21 11.5a8.38 8.38 0 0 1-9 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 9-8.5 8.5 8.5 0 0 1 9 8.5z"
                      />
                    </svg>
                  }
                  @if (item.icon === 'toolset') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                      />
                    </svg>
                  }
                  @if (item.icon === 'library') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                      <path
                        d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                      />
                      <path d="M8 7h8" />
                    </svg>
                  }
                  @if (item.icon === 'knowledge') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M9 18h6" />
                      <path d="M10 22h4" />
                      <path
                        d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"
                      />
                    </svg>
                  }
                  @if (item.icon === 'contact') {
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  }
                </span>
                <span class="nav-menu--item-title">
                  {{ item.title }}
                  @if (item.comingSoon) {
                    <span class="nav-menu--badge">Soon</span>
                  }
                </span>
              </a>
            }
          </div>
        </div>
      }
    </nav>

    <!-- Action Buttons -->
    <div class="header--actions">
      <!-- Accessibility Button (Mobile/Medium) -->
      <button
        class="header--accessibility-btn-mobile"
        (click)="toggleAccessibilityPanel()"
        aria-label="Accessibility options"
        [attr.aria-expanded]="isAccessibilityPanelOpen"
        type="button"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2Z"
            fill="currentColor"
          />
          <path
            d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
            fill="currentColor"
          />
          <path
            d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19Z"
            fill="currentColor"
          />
          <path
            d="M20 11H19C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11Z"
            fill="currentColor"
          />
          <path
            d="M6 12C6 11.4477 5.55228 11 5 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <!-- Accessibility (desktop, logged out): before Login — was previously at end of nav -->
      @if (!isLoggedIn) {
        <button
          class="header--accessibility-btn"
          (click)="toggleAccessibilityPanel()"
          aria-label="Accessibility options"
          [attr.aria-expanded]="isAccessibilityPanelOpen"
          type="button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2Z"
              fill="currentColor"
            />
            <path
              d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
              fill="currentColor"
            />
            <path
              d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19Z"
              fill="currentColor"
            />
            <path
              d="M20 11H19C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11Z"
              fill="currentColor"
            />
            <path
              d="M6 12C6 11.4477 5.55228 11 5 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12Z"
              fill="currentColor"
            />
          </svg>
        </button>
      }

      <!-- Show Login/Register buttons when NOT logged in -->
      @if (!isLoggedIn) {
        <button class="btn--login" (click)="onLogin()" type="button">
          Login
        </button>
        <button class="btn--register" (click)="onRegister()">Register</button>
      }

      <!-- Show User dropdown when logged in -->
      @if (isLoggedIn && showWorkspaceSwitcher) {
        <!-- My Workspace / context switcher (shown when user has delegated access) -->
        <div class="workspace--dropdown-container">
          <button
            #workspaceTrigger
            type="button"
            class="workspace--trigger"
            [class.active]="isWorkspaceDropdownOpen"
            [attr.aria-expanded]="isWorkspaceDropdownOpen"
            aria-haspopup="listbox"
            aria-label="Workspace"
            (click)="toggleWorkspaceDropdown($event)"
          >
            <span class="workspace--trigger-label">{{
              workspaceTriggerLabel
            }}</span>
            <span class="workspace--trigger-icon" aria-hidden="true">
              <img
                src="/icons/workspace-chevrons.svg"
                width="16"
                height="16"
                alt=""
              />
            </span>
          </button>

          @if (isWorkspaceDropdownOpen) {
            <div
              class="workspace--dropdown-menu"
              [style.top.px]="workspaceDropdownPosition.top"
              [style.right.px]="workspaceDropdownPosition.right"
              [style.max-height.px]="workspaceDropdownPosition.maxHeight"
              role="listbox"
              aria-label="Workspace context switcher"
              (click)="$event.stopPropagation()"
            >
              <div class="workspace--section-header">Current Workspace</div>
              <button
                type="button"
                class="workspace--row"
                [class.workspace--row-active]="isWorkspaceActive(ownWorkspace)"
                role="option"
                [attr.aria-selected]="isWorkspaceActive(ownWorkspace)"
                (click)="onSelectWorkspace(ownWorkspace)"
              >
                <span
                  class="workspace--avatar"
                  [style.background]="ownWorkspace.avatarColor"
                  >{{ ownWorkspace.initials }}</span
                >
                <span class="workspace--info">
                  <span class="workspace--name">{{ ownWorkspace.name }}</span>
                  <span class="workspace--role">{{
                    ownWorkspace.roleLabel
                  }}</span>
                </span>
              </button>

              @if (delegatedWorkspaces.length) {
                <div class="workspace--divider" aria-hidden="true"></div>
                <div
                  class="workspace--section-header workspace--section-header-delegated"
                >
                  Delegated Access
                </div>
                <div class="workspace--delegated-list">
                  @for (ws of delegatedWorkspaces; track ws.id) {
                    <button
                      type="button"
                      class="workspace--row"
                      [class.workspace--row-active]="isWorkspaceActive(ws)"
                      role="option"
                      [attr.aria-selected]="isWorkspaceActive(ws)"
                      (click)="onSelectWorkspace(ws)"
                    >
                      <span
                        class="workspace--avatar"
                        [style.background]="ws.avatarColor"
                        >{{ ws.initials }}</span
                      >
                      <span class="workspace--info">
                        <span class="workspace--name">{{ ws.name }}</span>
                        <span class="workspace--role">{{
                          ws.organisationName || '—'
                        }}</span>
                      </span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      <!-- Accessibility (desktop, logged in): after My Workspace, before avatar -->
      @if (isLoggedIn) {
        <button
          class="header--accessibility-btn"
          (click)="toggleAccessibilityPanel()"
          aria-label="Accessibility options"
          [attr.aria-expanded]="isAccessibilityPanelOpen"
          type="button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2Z"
              fill="currentColor"
            />
            <path
              d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
              fill="currentColor"
            />
            <path
              d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19Z"
              fill="currentColor"
            />
            <path
              d="M20 11H19C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11Z"
              fill="currentColor"
            />
            <path
              d="M6 12C6 11.4477 5.55228 11 5 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12Z"
              fill="currentColor"
            />
          </svg>
        </button>
      }

      @if (isLoggedIn) {
        <div class="user--dropdown-container">
          <button
            #dropdownTrigger
            class="user--dropdown-trigger"
            (click)="toggleUserDropdown($event)"
            [class.active]="isUserDropdownOpen"
            type="button"
          >
            <span class="user--avatar">{{ userInitials }}</span>
          </button>

          <!-- Dropdown Menu (fixed overlay so it is not clipped by header) -->
          @if (isUserDropdownOpen) {
            <div
              class="user--dropdown-menu"
              [style.top.px]="dropdownPosition.top"
              [style.right.px]="dropdownPosition.right"
              (click)="$event.stopPropagation()"
            >
              <ul class="dropdown--list">
                @if (!isAdmin) {
                  <li class="dropdown--item">
                    <button
                      class="dropdown--link"
                      [class.disabled]="isUpgradeDisabled"
                      [disabled]="isUpgradeDisabled"
                      (click)="onUpgradeRoleClick($event)"
                      type="button"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Upgrade Your Role
                    </button>
                  </li>
                }
                <li class="dropdown--item">
                  <button
                    class="dropdown--link"
                    (click)="navigateToDashboard(); closeUserDropdown()"
                    type="button"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Dashboard
                  </button>
                </li>
                @if (!isDelegateSession()) {
                <li class="dropdown--item">
                  <button
                    class="dropdown--link"
                    (click)="navigateToProfile()"
                    type="button"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Profile
                  </button>
                </li>
                }
                <li class="dropdown--item">
                  <a
                    routerLink="/contact-us"
                    class="dropdown--link"
                    (click)="closeUserDropdown()"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Contact Us
                  </a>
                </li>
              </ul>
              <div class="dropdown--divider"></div>
              <button
                class="dropdown--logout"
                (click)="onLogout()"
                type="button"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Sign Out
              </button>
            </div>
          }
        </div>
      }

      <!-- Hamburger Menu Button (Mobile Only) -->
      <button
        class="btn--hamburger"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu"
      >
        <span class="hamburger--icon">
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
        </span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu Overlay -->
  @if (isMobileMenuOpen) {
    <div class="mobile-menu--overlay" (click)="closeMobileMenu()"></div>
  }

  <!-- Mobile Menu -->
  <nav class="mobile-menu" [class.open]="isMobileMenuOpen">
    <ul class="mobile-menu--list">
      <li class="mobile-menu--item">
        <a
          routerLink="/about-mahaagx"
          class="mobile-menu--link"
          [class.mobile-menu--link-active]="isAboutPageActive()"
          (click)="closeMobileMenu()"
          >About MahaAgX</a
        >
      </li>
      <li class="mobile-menu--section-label">Assets</li>
      @for (item of assetsMenuItems; track item.route) {
        <li class="mobile-menu--item">
          <a
            [routerLink]="item.route"
            class="mobile-menu--link"
            [class.mobile-menu--link-active]="isNavMenuItemActive(item.route)"
            (click)="closeMobileMenu()"
            >{{ item.title }}</a
          >
        </li>
      }
      @if (!isHeaderLinkRestricted('/sandbox')) {
        <li class="mobile-menu--item">
          <a
            routerLink="/sandbox"
            class="mobile-menu--link"
            [class.mobile-menu--link-active]="isSandboxPageActive()"
            (click)="closeMobileMenu()"
            >Sandbox</a
          >
        </li>
      }
      <li class="mobile-menu--item">
        <a
          routerLink="/canvas"
          class="mobile-menu--link"
          [class.mobile-menu--link-active]="isCanvasPageActive()"
          (click)="closeMobileMenu()"
          >Canvas</a
        >
      </li>
      <li class="mobile-menu--item">
        <a
          routerLink="/leaderboard"
          class="mobile-menu--link"
          [class.mobile-menu--link-active]="isLeadershipPageActive()"
          (click)="closeMobileMenu()"
          >Leaderboard</a
        >
      </li>
      @if (visibleCommunityMenuItems.length) {
        <li class="mobile-menu--section-label">Community</li>
        @for (item of visibleCommunityMenuItems; track item.route) {
          <li class="mobile-menu--item">
            <a
              [routerLink]="item.route"
              class="mobile-menu--link"
              [class.mobile-menu--link-active]="isNavMenuItemActive(item.route)"
              (click)="closeMobileMenu()"
              >{{ item.title }}</a
            >
          </li>
        }
      }
      <li class="mobile-menu--section-label">Resources</li>
      @for (item of resourcesMenuItems; track item.route) {
        <li class="mobile-menu--item">
          <a
            [routerLink]="item.route"
            class="mobile-menu--link"
            [class.mobile-menu--link-active]="isNavMenuItemActive(item.route)"
            (click)="closeMobileMenu()"
            >{{ item.title }}</a
          >
        </li>
      }
      <li class="mobile-menu--item">
        <button
          class="mobile-menu--link mobile-menu--accessibility-btn"
          (click)="toggleAccessibilityPanel(); closeMobileMenu()"
          aria-label="Accessibility options"
          type="button"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            style="margin-right: 8px; vertical-align: middle"
          >
            <path
              d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2Z"
              fill="currentColor"
            />
            <path
              d="M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
              fill="currentColor"
            />
            <path
              d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19Z"
              fill="currentColor"
            />
            <path
              d="M20 11H19C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11Z"
              fill="currentColor"
            />
            <path
              d="M6 12C6 11.4477 5.55228 11 5 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H5C5.55228 13 6 12.5523 6 12Z"
              fill="currentColor"
            />
          </svg>
          Accessibility
        </button>
      </li>
      <li class="mobile-menu--item mobile-menu--actions">
        <!-- Show Login/Register in mobile when NOT logged in -->
        @if (!isLoggedIn) {
          <button
            class="btn--login-mobile"
            (click)="onLogin(); closeMobileMenu()"
          >
            Login
          </button>
          <button
            class="btn--register-mobile"
            (click)="onRegister(); closeMobileMenu()"
          >
            Register
          </button>
        }

        <!-- Show Logout in mobile when logged in -->
        @if (isLoggedIn) {
          <div class="user--name-mobile">{{ userName }}</div>
          <button
            class="btn--logout-mobile"
            (click)="onLogout(); closeMobileMenu()"
          >
            Logout
          </button>
        }
      </li>
    </ul>
  </nav>

  <!-- Accessibility Panel -->
  <app-accessibility-panel
    [isOpen]="isAccessibilityPanelOpen"
    (closePanel)="closeAccessibilityPanel()"
  >
  </app-accessibility-panel>

  <!-- Upgrade Role Modal -->
  <app-modal
    [(visible)]="isUpgradeModalVisible"
    header="Upgrade Your Role"
    [width]="'1000px'"
    [showFooter]="false"
  >
    <div class="upgrade-modal-content" style="overflow: visible">
      <!-- Intro Text -->
      <p class="roles-intro-text">
        Choose a role that aligns with how you want to use MahaAgX. Each role
        unlocks specific capabilities—whether you want to explore, publish
        assets on MahaAgX or run AI experiments.
      </p>

      <!-- Roles Grid -->
      <div class="roles-grid">
        @for (role of roles; track role.id) {
          <div class="role-card" [style.border-top-color]="role.color">
            <!-- Leaf Pattern Decoration -->
            <div class="role-card-leaf-pattern">
              <img src="/assets-leaf.png" alt="" class="role-card-leaf-image" />
            </div>

            <div class="role-card-header">
              <div
                class="role-icon-container"
                [style.background-color]="role.color + '15'"
              >
                <svg
                  class="role-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [style.color]="role.color"
                >
                  <path
                    [attr.d]="role.icon"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="role-title-container">
                <h3 class="role-card-title">{{ role.title }}</h3>
                @if (
                  (role.id === 'provider' && hasPendingProviderRole) ||
                  (role.id === 'compute' && hasPendingComputeRole)
                ) {
                  <span class="role-pending-badge"> Request Pending </span>
                }
                @if (
                  (role.id === 'provider' && hasProviderRole) ||
                  (role.id === 'compute' && hasComputeRole)
                ) {
                  <span class="role-granted-checkmark" title="Granted">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="checkmark-icon"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                  </span>
                }
              </div>
            </div>

            <p class="role-card-description">{{ role.description }}</p>

            <!-- Pending Organisation Note - Only for Data Provider when status is pending -->
            @if (role.id === 'provider' && showPendingOrganisationNote) {
              <div
                class="role-organisation-note role-organisation-note--pending"
              >
                <svg
                  class="organisation-note-icon"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="organisation-note-text"
                  >Your request has been sent waiting for
                  <span class="organisation-note-text--approval"
                    >approval</span
                  ></span
                >
              </div>
            }

            <!-- Granted Organisation Note - Only for Data Provider when status is granted -->
            @if (role.id === 'provider' && showGrantedOrganisationNote) {
              <div
                class="role-organisation-note role-organisation-note--granted"
              >
                <svg
                  class="organisation-note-icon"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="organisation-note-text"
                  >Your organisation has been approved</span
                >
              </div>
            }

            <!-- Organisation Requirement Note - Only for Data Provider when user doesn't have organisation -->
            @if (role.id === 'provider' && showOrganisationNote) {
              <div class="role-organisation-note">
                <svg
                  class="organisation-note-icon"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="organisation-note-text"
                  >You need to be part of an Organisation</span
                >
              </div>
            }

            <div class="role-features">
              @for (feature of role.features; track feature) {
                <div class="feature-item">
                  <svg
                    class="feature-icon"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    [style.color]="role.color"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span>{{ feature }}</span>
                </div>
              }
            </div>

            <!-- Request Upgrade Button for other states -->
            @if (
              (role.id !== 'compute' || !hasComputeRole) &&
              !isRoleRequestSent[role.id]
            ) {
              <button
                class="btn-request-upgrade"
                [class.role-granted]="role.id === 'provider' && hasProviderRole"
                [disabled]="isRoleButtonDisabled(role.id)"
                [style.background-color]="role.color"
                (click)="handleRoleSelection(role.id)"
              >
                {{ getRoleButtonText(role.id) }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </app-modal>
</header>
